<template>
  <div class="invoices-table">
    <AgGrid
      ref="agGrid"
      :options="gridOptions"
      :row-data="clonedInvoices"
      :context="context"
      @cell-value-changed="cellValueChanged"
    />
  </div>
</template>

<script>
import * as apiTo from '@/modular-api'
import { isNumber } from '@lib/generic.utils'
import { isDateValid } from '@lib/validation-helpers'
// Libraries
import { cloneDeep } from 'lodash'
// Mixins
import { gridOptions } from './gridOptions'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  mixins: [gridOptions],

  props: {
    invoices: {
      type: Array,
      required: true
    }
  },

  data: () => ({
    context: {}
  }),

  computed: {
    clonedInvoices() {
      return cloneDeep(this.invoices)
    }
  },

  created() {
    this.context = { invoiceTableCmp: this }
  },

  methods: {
    // called from `ActionsColumn.vue`
    finalize(row) {
      const data = cloneDeep(row)
      data.finalized = true

      this.$emit('finalized', data)
    },

    cellValueChanged(event) {
      const payload = this.getPayload(event)

      if (!payload) return

      apiTo
        .PROCESS_TASK('vendor-payments', payload.id, payload)
        .then(({ data }) => {
          const index = this.invoices.findIndex(v => v.id === data.result.id)
          const invoices = this.clonedInvoices

          if (~index) {
            invoices.splice(index, 1, data.result)
            this.$emit('update:invoices', invoices)
          }
        })
        .catch(() => {
          const invoices = cloneDeep(this.invoices)
          this.$refs.agGrid.updateRows(invoices)
        })
    },

    getPayload(event) {
      if (!this.didValueChanged(event.oldValue, event.newValue)) return

      const row = cloneDeep(event.data)
      const updatedField = event.colDef.field

      row[updatedField] = event.newValue

      if (updatedField === 'exchange_rate' && row[updatedField]) {
        const { newValue, oldValue } = event

        if (isNumber(newValue) && isNumber(oldValue) && Number(newValue) === Number(oldValue)) return
        row.paid_amount = Number(row.amount) * Number(row.exchange_rate)
      } else if (updatedField === 'paid_amount') {
        row.exchange_rate = Number(row.paid_amount) / Number(row.amount)
      }

      if (row.payment_date === 'N/A') row.payment_date = null
      else if (isDateValid.call(this, row.payment_date)) {
        row.payment_date = this.formatDateForPost(row.payment_date, this.settings.date_format)
      }

      return row
    },

    didValueChanged(old, newVal) {
      if (typeof old === 'string' && typeof newVal === 'number') return Number(old) !== Number(newVal)
      return old !== newVal
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins.scss';

.invoices-table {
  @include table-with-no-filters;

  ::v-deep .ag-details-row {
    background: var(--r-white-2);
    padding: var(--r-space-sm) var(--r-space-xxl);

    > .ag-theme-alpine {
      max-width: 600px;
    }
  }
}
</style>
